import { React, useState, useEffect } from "react";
import "./SeasonShowcase.css";
import { EpisodeTagCarousel } from "../EpisodeTag/EpisodeTagCarousel.js";
import { useDispatch, useSelector } from "react-redux";
import { getSeasonDetail } from "../../page/DetailsPage/DetailSlice.js";

export const SeasonShowcase = (props) => {
  const { detailData, tvId, title } = props;
  //const [selectedSeason, setSelectedSeason] = useState("0"); //MidAutumn Remove
  //const [seasonData, setSeasonData] = useState(detailData[0]);

  let [selectedSeason, setSelectedSeason] = useState(null);
  let [seasonData, setSeasonData] = useState(null);

  const num_of_seasons =
    detailData.length > 1
      ? detailData.length + " Seasons"
      : detailData.length + " Season";

  function handleSeasonSelect(event) {
    setSelectedSeason(event.target.value);
  }

  //MidAutumn Initiate SelectedSeason
  let dispatch = useDispatch();

  useEffect(() => {
    let targetSeason = detailData.filter((item) => item.season_number == 0);
    if (targetSeason.length == 0) {
      setSelectedSeason("1");
    } else {
      setSelectedSeason("0");
    }
  }, [detailData, tvId]);

  //Update SeasonData when SelectedSeason change
  useEffect(() => {
    let targetSeason = detailData.filter(
      (item) => item.season_number == selectedSeason
    );
    if (targetSeason.length == 0) {
      targetSeason = detailData.filter(
        (item) => item.season_number == selectedSeason + 1
      );
    }

    if (selectedSeason) {
      dispatch(
        getSeasonDetail({
          tvId: tvId,
          seasonNumber: targetSeason[0].season_number,
        })
      ).then((res) => {
        setSeasonData(res.payload);
      });
    }
  }, [selectedSeason]);

  /*  //Update Season Data when selected Season change
  useEffect(() => {
    setSeasonData(() => {
      let targetSeason = detailData.filter((item) => item.season_number == selectedSeason);
      if (targetSeason.length == 0){
        targetSeason = detailData.filter(item => item.season_number == selectedSeason + 1);
      }
      return targetSeason[0]
    });
  }, [selectedSeason]);

  let dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getSeasonDetail({
        tvId: tvId,
        seasonNumber: seasonData.season_number,
      })
    );
  }, [seasonData]);

  let seasonDetail = useSelector(
    (state) => {
      let targetSeason = state.detail.detailList.tvList[tvId].seasons.filter(item => item.season_number == seasonData.season_number);
      return targetSeason[0]["seasonDetail"];  
    }
      
  );*/

  let seasonDetail = useSelector((state) => {
    if (!selectedSeason || !state.detail.detailList.tvList[tvId]) {
      return null;
    } else {
      let targetSeason = state.detail.detailList.tvList[tvId].seasons.filter(
        (item) => item.season_number == selectedSeason
      );
      return targetSeason.length > 0 ? targetSeason[0]["seasonDetail"]: null;
    }
  });

  if (!seasonData || !seasonDetail) {
    return <>Loading</>;
  }

  return (
    <div className="tv_season_showcase_wrapper">
      <div className="tv_season_showcase_header">
        <div className="season_showcase_title">
          {title}: {num_of_seasons}
        </div>
        <div className="season_showcase_control">
            <div className="season_showcase_season_pick">
              <select
                name="picked_season"
                id="picked_season"
                onChange={handleSeasonSelect}
              >
                <option disabled value="">
                  Select Season
                </option>
                {detailData.map((season, index) => (
                  <option key={index} value={season.season_number}>
                    {season.name}
                  </option>
                ))}
              </select>
            </div>
        </div>
      </div>
      <div className="tv_season_showcase_container">
        <div className="season_content_wrapper">
          <div className="season_name">
            {
              detailData.find((item) => item.season_number == selectedSeason)
                .name
            }
          </div>
          <span className="season_content_breakline"></span>
          <div className="season_ep_count">
            {detailData.find((item) => item.season_number == selectedSeason)
              .episode_count > 1
              ? detailData.find((item) => item.season_number == selectedSeason)
                  .episode_count + " Episodes"
              : detailData.find((item) => item.season_number == selectedSeason)
                  .episode_count + " Episode"}
          </div>
        </div>
        <div className="season_episodes_wrapper">
          {seasonDetail.seasonLoading ? (
            <h3>Season Loading...</h3>
          ) : seasonDetail.seasonError ? (
            <h3>Season Error 404</h3>
          ) : (
            <EpisodeTagCarousel episodes={seasonData.episodes} />
          )}
        </div>
      </div>
    </div>
  );
};
